import { render, staticRenderFns } from "./GroupDetail.vue?vue&type=template&id=51de810b&scoped=true"
import script from "./GroupDetail.vue?vue&type=script&lang=js"
export * from "./GroupDetail.vue?vue&type=script&lang=js"
import style0 from "./GroupDetail.vue?vue&type=style&index=0&id=51de810b&prod&lang=scss&scoped=true"
import style1 from "./GroupDetail.vue?vue&type=style&index=1&id=51de810b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51de810b",
  null
  
)

export default component.exports